import { useSummaryPerInPackage } from "api/trading-documents/hooks";
import { CommonError, DisabledOpacity, MockupLoader } from "components/utils";
import { DrawerRightPanel, RightPanelBody } from "components/utils/drawer";
import { useQuery } from "hooks";
import cx from "classnames";
import styles from "../../../WarehouseFinancialState.module.css";
import { PanelHeader } from "pages/tradingDocuments/warehouseFinancialState/shared/rightPanel/PanelHeader";
import { TitleSection } from "pages/tradingDocuments/warehouseFinancialState/shared/rightPanel/TitleSection";
import { WhEntriesSection } from "pages/tradingDocuments/warehouseFinancialState/shared/rightPanel/WhEntriesSection";

interface Props {
  close: () => void;
}

export const RightPanel = ({ close }: Props) => {
  const { query } = useQuery();
  const { packageIn } = query;
  const keys = Object.keys(query);

  const { data: summaryPerPackage, error, isLoading } = useSummaryPerInPackage(
    { id: packageIn },
    {
      enabled: Boolean(packageIn),
    },
  );

  if (error) {
    return (
      <DrawerRightPanel>
        <CommonError status={error._httpStatus_} />
      </DrawerRightPanel>
    );
  }

  if (isLoading) {
    return (
      <DrawerRightPanel>
        <MockupLoader type="drawer" />
      </DrawerRightPanel>
    );
  }

  if (!summaryPerPackage) return null;

  return (
    <DrawerRightPanel
      className={cx(styles.rightPanelPositioning, {
        [styles.rightPanelVisibility]: keys.indexOf("packageIn") > keys.indexOf("packageOut"),
      })}
      key={summaryPerPackage.id}
    >
      <PanelHeader close={close} title="Przyjęta paczka" />
      <DisabledOpacity disabled={isLoading}>
        <RightPanelBody>
          <TitleSection internalId={summaryPerPackage.internalId} title={summaryPerPackage.name} />
          <WhEntriesSection summary={summaryPerPackage} title="Przyjęcia" />
        </RightPanelBody>
      </DisabledOpacity>
    </DrawerRightPanel>
  );
};
